<div>
  <span placement="right" pTooltip="{{entityTypeKey | translate}}" tooltipPosition="right" showDelay="250">{{entityType}}</span>
  <div class="icon-wrapper" (click)="openMswfRules($event);" *ngIf="params?.data?.multiStepWorkflow"  pTooltip="{{'multistep.workflow.button' | translate}}" showDelay="250"><i class="icon-workflow"></i></div>
</div>
